import React from 'react';
import Media from '../media';
import Anchor from '../anchor';
import Button from '../button';
import Login from '../login/login';
import Logout from '../logout';
import { useMsal } from '@azure/msal-react';
import { resetCreateTeamReduxState } from 'store/slice/loginSlice';
import { useDispatch } from 'react-redux';
import { IMG_BASE_PATH } from 'utils/constants';
import config from 'utils/config';
import { handleNavigation, isWebView } from 'utils/commonFunctions';

const GameHeader = () => {
  const isCta = true;
  const { accounts } = useMsal();
  const dispatch = useDispatch();

  const navigateToOpposite = () => {
    dispatch(resetCreateTeamReduxState());
  };

  return (
    <section className='si-gameHeader__wrap'>
      <div className='si-main__container'>
        <div className='si-gameHeader__grid'>
          <div className='si-gameHeader__grid-lhs'>
            <div className='si-gameHeader__logo'>
              {isWebView() ? (
                <Media imgSrc={`${IMG_BASE_PATH}images/game-logo/game-logo.svg`} imgAlt='logo' />
              ) : (
                <a href='https://www.icc-cricket.com/tournaments/champions-trophy-2025'>
                  <Media imgSrc={`${IMG_BASE_PATH}images/game-logo/game-logo.svg`} imgAlt='logo' />
                </a>
              )}
            </div>

            {isCta ? '|' : null}

            <div className='si-gameHeader__title'>
              <Anchor
                variant={'primary'}
                classes={''}
                linkTarget={'_self'}
                transKey={window?.['translations']?.['icc_home_lbl'] || 'ICC HOME'}
                hyperLink={
                  !isWebView()
                    ? 'https://www.icc-cricket.com/tournaments/champions-trophy-2025'
                    : undefined
                }
              />
            </div>
          </div>

          <div className='si-gameHeader__grid-rhs'>
            {config.otherGameCards.map((item, index) =>
              isCta ? (
                <div className='si-gameHeader__cta' key={index}>
                  <Button
                    variant='primary'
                    classes='si-btn__toggleGame'
                    onClick={() => handleNavigation(item.url)}
                    transKey='cta_predictor'
                  />
                </div>
              ) : null
            )}

            {isCta ? '|' : null}

            <div className='si-gameHeader__login'>{!accounts.length ? <Login /> : <Logout />}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GameHeader;
